Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Ellipsis661197153",
  {"text":"Ellipsis661197153--text","tooltip":"Ellipsis661197153--tooltip","root":"Ellipsis661197153--root"},
  ".Ellipsis661197153--text{white-space:nowrap!important;text-overflow:ellipsis!important;overflow:hidden!important;max-width:100%!important;display:inline-block!important;vertical-align:bottom!important}.Ellipsis661197153--tooltip{display:inline;overflow:hidden;height:max-content}.Ellipsis661197153--tooltip .Popover194516669--popoverElement{max-width:100%}",
  8,
  "Ellipsis661197153"
);
__webpack_require__.stylable.$.register(exports.default)
